import { render } from "./sessionpopup.vue?vue&type=template&id=c99e8ffa&scoped=true&ts=true"
import script from "./sessionpopup.vue?vue&type=script&lang=ts"
export * from "./sessionpopup.vue?vue&type=script&lang=ts"

import "./sessionpopup.vue?vue&type=style&index=0&id=c99e8ffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c99e8ffa"]])

export default __exports__